import { FC, useEffect, useRef, useState } from 'react'

import { Close } from '@mui/icons-material'
import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import TextField from '@mui/material/TextField/TextField'

import { useField, useFormikContext } from 'formik'

import { ELEMENT_RADIUS_MID } from 'utils/customizedTheme'
import InfoTooltip from '../buttons/InfoTooltip'

interface IProps {
  fieldProps: {
    name: string
    label: string
    type?: string
    min?: number
    max?: number
    required?: boolean
  }
  inputProps?: any
  icon?: any
  hint?: string
  valueSelector?: string
  placeholder?: string
  sx?: any
  onChange?: any
  multiline?: boolean
  maxRows?: number
  disabled?: boolean
  focused?: boolean
  clearRight?: string
  readOnly?: boolean
  hideClear?: boolean
}

const InputField: FC<IProps> = ({
  fieldProps,
  inputProps={},
  icon,
  hint,
  valueSelector,
  sx = {},
  onChange,
  multiline = false,
  disabled,
  maxRows,
  focused = false,
  placeholder,
  clearRight,
  readOnly,
  hideClear
}) => {




  const [showClear, setShowClear] = useState(false)
  const inputRef = useRef(null)

  const [field, meta] = useField(fieldProps.name)
  const { setFieldValue } = useFormikContext()
  const { touched, error } = meta
  const renderHelperText = () => {
    if (touched && error) {
      let errorText = error
      if (valueSelector) {
        errorText = error[valueSelector]
      }

      if (typeof errorText !== 'string') {
        errorText = ''
      }
      return errorText
    }
  }


  const value = valueSelector ? field.value[valueSelector] : field.value

  const [internalValue, setInternalValue] = useState(value)

  useEffect(() => {        
    setInternalValue(value)
  }, [value]) // eslint-disable-line react-hooks/exhaustive-deps
  
  const setFormValue = (value) => {
    let newValue = value;
    if (valueSelector) {
      newValue = {
        ...field.value,
        [valueSelector]: value,
      }
    }
    setFieldValue(fieldProps.name, newValue)
    if (onChange) onChange(newValue)
  }

  useEffect(() => {        
    setFormValue(internalValue)
  }, [internalValue]) // eslint-disable-line react-hooks/exhaustive-deps
  
  return (
    <Box className="transparent-background"
      sx={{
        display: 'flex',
        alignItems: 'flex-end',
        position: 'relative',
        // paddingBottom: '1.2rem',
        borderRadius: ELEMENT_RADIUS_MID,
        '& fieldset': { borderRadius: ELEMENT_RADIUS_MID },
        ...sx,
      }}
      onMouseEnter={() => {
        setShowClear(true)
      }}
      onMouseLeave={() => {
        setShowClear(false)
      }}
    >
      {icon && <span style={{ position: 'absolute', top: '0.45rem', left: '0.5rem', zIndex: 1 }}>{icon}</span>}
      <TextField
        error={error && touched}
        inputRef={inputRef}
        // variant='standard'
        autoFocus={focused}
        helperText={renderHelperText()}
        placeholder={placeholder}
        fullWidth
        maxRows={maxRows}
        multiline={multiline}
        disabled={disabled}
        {...field}
        {...fieldProps}
        value={internalValue}
        onChange={(e) => {
            let newValue = fieldProps.type === 'number' ? Number(e.target.value) :  e.target.value
            setInternalValue(newValue)
        }}
        inputProps={{
          ...inputProps,
          style: {
            paddingRight: fieldProps.type === 'number' && 0,
            padding: multiline ? '0' : `0.75rem 0.75rem 0.75rem ${icon ? '2.5rem' : '0.75rem'}`,
          },
          readOnly: readOnly
          // min: fieldProps.min,
          // max: fieldProps.max,
        }}
        InputLabelProps={{
          // shrink: false, stop label animation
          style: { left: icon && '1.5rem' },
        }}
      />
      {!disabled && showClear && !hideClear && Boolean(field?.value) && (
        <Button
          color='neutral'
          aria-label='clear'
          tabIndex={2}
          sx={{
            borderRadius: '50%',
            minWidth: '2.2rem',
            width: '2.2rem',
            height: '2.2rem',
            position: 'absolute',
            top: '0.4rem',
            right: clearRight ? clearRight : fieldProps.type === 'number' ? 23 : 6,
            zIndex: '300',
          }}
        >
          <Close
            onClick={() => {
              setInternalValue('')
              setFormValue('')  
            }}
          />
        </Button>
      )}

      {hint && <div style={{
        position: 'absolute',
        zIndex: '2',
        top: '-10px',
        right: '-10px'
      }}><InfoTooltip hint={hint}></InfoTooltip></div>}
    </Box>
  )
}
export default InputField
